<template>
  <div class="element-manage-container">
    <DragPanel
      class="drapTree"
      v-show="catalogTreeVisible">
      <CatalogTree
        :width="260"
        ref="catalogTree"
        type="PublicElem"
        :data="catalogData"
        :updateData="updateData"
        :nodeClick="handleNodeClick"
        :hideCatalogTree="hideCatalogTree" />
    </DragPanel>
    <!-- <div
      v-if="!catalogTreeVisible"
      class="collapse-icon-box">
      <icon-svg
        icon-class="ic-ico_an"
        class="icon"
        title="展开目录树"
        @click.native="openCatalogTree" />
    </div> -->
    <div class="elements-box outer-page-primary">
      <div class="header-box head-box">
        <Breadcrumb
          :breadcrumbList="breadcrumbList"
          :breadcrumbClick="breadcrumbClick" />
        <div class="common-button-box btn-group-primary">
          <el-button
            size="small"
            class="normal-btn gr16"
            @click="openUploadDialog"
            v-if="isChecked('Project.ComponentLibrary.Public.Upload')">
            <div class="icon-box">
              <icon-svg
                icon-class="icon-shangchuanliebiao"
                class="icon" />
              <span>上传列表</span>
            </div>
          </el-button>
          <el-button
            size="small"
            class="normal-btn gr16"
            @click="openQueueDialog"
            v-if="isChecked('Project.ComponentLibrary.Public.Upload')">
            <div class="icon-box">
              <icon-svg
                icon-class="icon-zhuanhuanduilie"
                class="icon" />
              <span>转换队列</span>
            </div>
          </el-button>
          <el-button
            class="gl16"
            size="small"
            type="text"
            title="切换视图"
            @click="switchMode">
            <div class="icon-box changeView">
              <icon-svg
                siz="16"
                v-if="viewMode === 'card'"
                icon-class="icon-liebiaoshitu1"
                class="icon" />
              <icon-svg
                siz="16"
                v-if="viewMode === 'table'"
                icon-class="icon-suolvetushitu"
                class="icon" />
            </div>
          </el-button>
        </div>
      </div>
      <div class="operation-box">
        <div class="common-button-box">
          <el-button
            v-if="isChecked('Project.ComponentLibrary.Public.Upload')"
            key="uploadBtn"
            type="primary"
            size="small"
            class="upload-btn primary-btn gr8"
            id="element-upload"
            @click="uploadFile"
            >上传</el-button
          >
          <div
            class="common-dropdown-box"
            v-if="isChecked('Project.ComponentLibrary.Public.Upload')">
            <el-dropdown
              :append-to-body="false"
              placement="bottom-start"
              @command="batchOperate">
              <el-button
                size="small"
                class="normal-btn">
                批量操作 <i class="el-icon-arrow-down"></i>
              </el-button>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-primary">
                <el-dropdown-item command="1">下载</el-dropdown-item>
                <el-dropdown-item command="2">删除 </el-dropdown-item>
                <el-dropdown-item command="3">移动到</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label searchLabel gr16">筛选</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                v-model="filterValue"
                size="small"
                @change="switchFilterValue"
                popper-class="common-select-dropdown primary-select-outer">
                <el-option
                  value="All"
                  label="全部" />
                <el-option
                  value="MyFavorites"
                  label="我的收藏" />
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label searchLabel gl16">排序</div>
            <div class="common-select-box gl16">
              <el-select
                class="primary-select"
                v-model="sortValue"
                size="small"
                @change="switchSortValue"
                popper-class="common-select-dropdown primary-select-outer">
                <el-option
                  value="LastUsedDate"
                  label="最近使用" />
                <el-option
                  value="UsageCount"
                  label="使用次数" />
                <el-option
                  value="UploadTime"
                  label="上传时间" />
                <el-option
                  value="MostFavorites"
                  label="收藏最多" />
              </el-select>
            </div>
          </div>
          <div class="filter-item-box gl16">
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="keywords"
                placeholder="请输入模型名称"
                clearable
                @clear="search"
                @keyup.enter.native="search">
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search icon"
                  @click="search" />
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="element-list-box">
        <CardList
          ref="cardList"
          v-if="viewMode === 'card'"
          :initCatalog="initCatalog"
          :elemUploader="elemUploader"
          :currNode="selectedNode"
          :filterValue="filterValue"
          :sortValue="sortValue"
          :keywords="keywords"
          :openMoveDialog="openMoveDialog"
          :openThumbnailDialog="openThumbnailDialog" />
        <TableList
          ref="tableList"
          v-if="viewMode === 'table'"
          :initCatalog="initCatalog"
          :elemUploader="elemUploader"
          :currNode="selectedNode"
          :filterValue="filterValue"
          :sortValue="sortValue"
          :keywords="keywords"
          :openMoveDialog="openMoveDialog" />
      </div>
    </div>
    <MoveDialog
      :visible="moveDialogVisible"
      type="PublicElem"
      :currNode="selectedNode"
      :elemsToMove="elemsToMove"
      :initCatalog="initCatalog"
      :updateDataList="updateDataList"
      :closeDialog="closeMoveDialog" />
    <ThumbnailDialog
      :visible="thumbnailDialogVisible"
      type="PublicElem"
      :elemInfo="elemToUpdateImg"
      :updateDataList="updateDataList"
      :closeDialog="closeThumbnailDialog" />
    <ElemUploadList
      :visible="uploadListVisible"
      type="PublicElem"
      :elemUploader="elemUploader"
      :closeDialog="closeUploadDialog" />
    <MiniElemUploadList
      :elemUploader="elemUploader"
      type="PublicElem" />
    <ElemQueue
      :visible="queueVisible"
      type="PublicElem"
      :closeDialog="closeQueueDialog" />
  </div>
</template>

<script>
import DragPanel from '@/components/DragPanel.vue'
import CatalogTree from './components/CatalogTree.vue'
import Breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'
import CardList from './publicElement/CardList.vue'
import MoveDialog from './components/MoveDialog.vue'
import ThumbnailDialog from './components/ThumbnailDialog.vue'
import TableList from './publicElement/TableList.vue'
import ElemQueue from './components/ElemQueue.vue'
import ElemUploadList from './components/ElemUploadList.vue'
import MiniElemUploadList from './components/MiniElemUploadList.vue'

import ElemUploader from '@/utils/elemUploader'
import { Store } from '@/utils/store'
import { getParentNode } from '@/utils/generalMethods'

import {
  publicElemCatalogService,
  publicElemFileListService,
  publicElemBatchPauseUploadService
} from '@/service/interface'

export default {
  data() {
    return {
      catalogTreeVisible: true,
      catalogRootId: '00000000-0000-0000-0000-000000000000',
      catalogData: [],
      breadcrumbList: [],
      viewMode: 'card',
      selectedNode: {},
      filterValue: 'All',
      sortValue: 'LastUsedDate',
      keywords: '',

      moveDialogVisible: false,
      elemsToMove: [],

      thumbnailDialogVisible: false,
      elemToUpdateImg: {},

      uploadListVisible: false,

      queueVisible: false
    }
  },
  components: {
    DragPanel,
    CatalogTree,
    Breadcrumb,
    CardList,
    MoveDialog,
    ThumbnailDialog,
    TableList,
    ElemQueue,
    ElemUploadList,
    MiniElemUploadList
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'CLPublicDoc')
    if (find) {
      this.elemUploader = find.uploader
      this.elemUploader.setCurrNodeId('')
      this.elemUploader.setUploadPathName('')
    } else {
      this.elemUploader = new ElemUploader('CLPublicDoc')
    }

    if (this.isChecked('Project.ComponentLibrary.Public.Upload')) {
      this.pauseFilesUpload()
    }
  },
  mounted() {
    this.initCatalog().then(() => {
      let nodeData = this.catalogData[0]
      let node = this.$refs.catalogTree.getNode(nodeData.nodeId)
      this.handleNodeClick(nodeData, node)
    })

    this.elemUploader.on('uploadFinish', this.onUploadFinish)

    window.addEventListener('unload', this.onUnLoad)
  },
  beforeDestroy() {
    this.elemUploader.off('uploadFinish', this.onUploadFinish)
  },
  methods: {
    onUnLoad() {
      sessionStorage.setItem('pauseFlag', false)
    },
    pauseFilesUpload() {
      let params = {
        resultCount: 1000,
        skipCount: 0,
        name: '',
        status: [1]
      }
      publicElemFileListService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let uploadingList = data.items

          uploadingList = uploadingList.filter(el => el.isMineUpload)
          let filesToPause = uploadingList.map(fileInfo => {
            let obj = {
              fileId: fileInfo.fileId,
              fileDataId: fileInfo.id
            }
            return obj
          })
          if (filesToPause.length) {
            this.batchPauseFiles(filesToPause)
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    batchPauseFiles(filesToPause) {
      let formData = new FormData()
      let FileIds = filesToPause.map(el => el.fileId)
      let FileDataIds = filesToPause.map(el => el.fileDataId)
      formData.append('FileIds', FileIds)
      formData.append('FileDataIds', FileDataIds)
      publicElemBatchPauseUploadService(formData).then(response => {
        if (response.isSuccess) {
          sessionStorage.setItem('pauseFlag', true)
        }
      })
    },
    initCatalog() {
      return new Promise(resolve => {
        let params = {
          parentId: this.catalogRootId,
          returnCount: true,
          lazyLoading: false
        }
        publicElemCatalogService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let catalogData = [
              {
                nodeId: this.catalogRootId,
                nodeName: '公共构件',
                nodeType: { value: 0, displayName: '根节点' },
                count: data.count,
                nodes: data.nodes
              }
            ]
            this.catalogData = catalogData
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    openCatalogTree() {
      this.catalogTreeVisible = true
    },
    hideCatalogTree() {
      this.catalogTreeVisible = false
    },
    handleNodeClick(nodeData, node) {
      if (nodeData.nodeId === this.selectedNode.nodeId) return

      this.$refs.catalogTree.setCurrentKey(nodeData.nodeId)
      this.selectedNode = nodeData

      this.breadcrumbList = this.getBreadCrumbList(node)

      this.clearFilter()
      this.updateDataList()

      this.$nextTick(() => {
        this.initUploadBtn()

        let uploadPathName = this.getUploadPathName()
        this.elemUploader.setCurrNodeId(this.selectedNode.nodeId)
        this.elemUploader.setUploadPathName(uploadPathName)
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('element-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.elemUploader.uploader.addButton({ id: '#element-upload' })
        }
      }
    },
    breadcrumbClick(data) {
      if (this.breadcrumbList.length === 1) return
      let selectData = this.findNodeById(this.catalogData, data.id)
      let node = this.$refs.catalogTree.getNode(selectData.nodeId)
      this.handleNodeClick(selectData, node)
    },
    openUploadDialog() {
      this.uploadListVisible = true
    },
    closeUploadDialog() {
      this.uploadListVisible = false
    },
    openQueueDialog() {
      this.queueVisible = true
    },
    closeQueueDialog() {
      this.queueVisible = false
    },
    switchMode() {
      this.clearFilter()

      if (this.viewMode === 'card') {
        this.viewMode = 'table'
      } else {
        this.viewMode = 'card'
      }
    },
    uploadFile() {
      this.elemUploader.setStatus('waiting')
    },
    batchOperate(command) {
      let dom = this.$refs[`${this.viewMode}List`]
      switch (command) {
        case '1':
          dom.batchDownloadElem()
          break
        case '2':
          dom.batchDeleteElement()
          break
        case '3':
          dom.batchMoveNode()
          break
      }
    },
    switchFilterValue() {
      this.updateDataList()
    },
    switchSortValue() {
      this.updateDataList()
    },
    search() {
      this.updateDataList()
    },
    onUploadFinish() {
      this.initCatalog().then(() => {
        let nodeId = this.selectedNode.nodeId
        this.$refs.catalogTree.setCurrentKey(nodeId)
        this.updateDataList()
      })
    },
    openMoveDialog(datas) {
      this.elemsToMove = datas
      this.moveDialogVisible = true
    },
    closeMoveDialog() {
      this.elemsToMove = []
      this.moveDialogVisible = false
    },
    openThumbnailDialog(data) {
      this.elemToUpdateImg = data
      this.thumbnailDialogVisible = true
    },
    closeThumbnailDialog() {
      this.elemToUpdateImg = {}
      this.thumbnailDialogVisible = false
    },
    updateDataList() {
      this.$nextTick(() => {
        if (this.viewMode === 'card') {
          this.$refs.cardList.initDataList()
        } else {
          this.$refs.tableList.initDataList()
        }
      })
    },
    updateCatalog(nodeId) {
      return new Promise(resolve => {
        this.initCatalog().then(() => {
          let nodeData = this.findNodeById(this.catalogData, nodeId)
          if (nodeData) {
            let node = this.$refs.catalogTree.getNode(nodeId)
            this.handleNodeClick(nodeData, node)
          } else {
            let nodeData = this.catalogData[0]
            let node = this.$refs.catalogTree.getNode(nodeData.nodeId)
            this.handleNodeClick(nodeData, node)
          }
          resolve()
        })
      })
    },
    updateData(nodeId) {
      return new Promise(resolve => {
        this.updateCatalog(nodeId).then(() => {
          let nodeData = this.findNodeById(this.catalogData, nodeId)
          if (nodeData) {
            let node = this.$refs.catalogTree.getNode(nodeId)
            this.handleNodeClick(nodeData, node)
          } else {
            let nodeData = this.catalogData[0]
            let node = this.$refs.catalogTree.getNode(nodeData.nodeId)
            this.handleNodeClick(nodeData, node)
          }
          resolve()
        })
      })
    },
    clearFilter() {
      this.filterValue = 'All'
      this.sortValue = 'LastUsedDate'
      this.keywords = ''
    },
    getBreadCrumbList(node) {
      let parentNodes = []
      this.getParentNode(node, parentNodes)
      parentNodes.reverse()
      let breadcrumbList = []
      parentNodes.forEach(item => {
        let nodeData = item.data
        let nodeType = nodeData.nodeType.value
        let obj = {
          id: nodeData.nodeId,
          name: nodeType === 0 ? '全部' : nodeData.nodeName,
          isElement: true
        }
        breadcrumbList.push(obj)
      })
      return breadcrumbList
    },
    getUploadPathName() {
      let uploadPathName = ''
      let tempArray = this.breadcrumbList.map((item, index) => {
        if (index === 0) {
          return '公共构件'
        } else {
          return item.name
        }
      })
      uploadPathName = tempArray.join('/')
      return uploadPathName
    },
    findNodeById(data, id) {
      for (const node of data) {
        if (node.nodeId === id) return node
        if (node.nodes && node.nodes.length) {
          const res = this.findNodeById(node.nodes, id)
          if (res) return res
        }
      }
      return null
    },
    getFilesToPause(uploadingList) {
      let filesToPause = []
      uploadingList.forEach(fileInfo => {
        filesToPause.push({
          fileId: fileInfo.fileId,
          fileDataId: fileInfo.id
        })
      })
      return filesToPause
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getParentNode
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');
@import url('@/assets/css/pageStyle.less');
.element-manage-container {
  display: flex;
  height: 100%;
  background-color: var(--base-bg-light-color49);

  .collapse-icon-box {
    position: absolute;
    margin-left: -10px;
    margin-top: -10px;
    height: 32px;
    background: var(--icon-bg-color2);
    z-index: 2;
    padding: 5px;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      color: var(--primary-color);
    }
  }

  .elements-box {
    position: relative;
    flex-grow: 1;
    box-shadow: none;
    overflow: hidden;
    .head-box {
      display: flex;
      justify-content: space-between;

      .common-button-box {
        display: flex;
        .el-button {
          height: 32px;
        }

        .changeView {
          .icon {
            color: var(--element-page-search-icon-color);
            &:hover {
              color: var(--base-primary-bgColor);
            }
          }
        }

        // .el-button--text {
        //   color: var(--default-color);
        //   // margin-left: 5px;
        //   padding: 0px;
        // }

        .icon-box {
          display: flex;
          font-size: 14px;

          .icon {
            font-size: 20px;
          }
        }
      }
    }

    .operation-box {
      display: flex;
      justify-content: space-between;

      .common-button-box {
        display: flex;

        .upload-btn {
          // padding: 0px 30px;
        }
      }

      .filter-box {
        display: flex;

        .filter-item-box {
          display: flex;

          .label {
            line-height: 32px;
          }

          .common-select-box {
            width: 120px;
            text-align: left;
          }
        }
      }
    }

    .element-list-box {
      height: calc(100% - 122px);
      margin-top: 16px;
      padding: 0 16px;
    }
  }
}
</style>
